// extracted by mini-css-extract-plugin
module.exports = {"button":"PlainButton_button__3_W3I","disabled":"PlainButton_disabled__2yzLE"};